import { useFetch } from '../../hooks/useFetch';
import {
	EasyStepRowWithSteps,
	ExpandedEasyStepsRowBlockWithExpandedSteps,
} from '../../types/optimizely/blocks/easyStepsBlock';

export const useEasyStepRowBlockData = (
	blockId: string,
): EasyStepRowWithSteps | null => {
	const { data } =
		useFetch<ExpandedEasyStepsRowBlockWithExpandedSteps>(blockId);
	if (data) {
		return {
			rowTitle: data?.rowTitle?.value,
			steps:
				data?.steps?.expandedValue?.map((step) => ({
					title: step.title.value,
					text: step.text.value,
					appStoreUrl: step?.appStoreUrl?.value,
					googlePlayUrl: step?.googlePlayUrl?.value,
					displayDownloadUrls: step?.displayDownloadUrls?.value,
					downloadAppFromAppstoreLabel:
						step.downloadAppFromAppstoreLabel?.value !== ''
							? step.downloadAppFromAppstoreLabel?.value
							: 'Get it on',
					downloadAppFromGooglePlayLabel:
						step.downloadAppFromGooglePlayLabel?.value !== ''
							? step.downloadAppFromGooglePlayLabel?.value
							: 'Download on the',
				})) ?? [],
		};
	}

	return null;
};
